import { axiosInstance } from '../../config/http';

export const getCountries = async () => {
  const res = await axiosInstance.get(`/mst/countries`);
  return res;
};
